import { useEffect } from 'react'

/* eslint-disable react-hooks/exhaustive-deps */

export const useTemplateForm = (setCrid, crid) => {
  useEffect(() => {
    setCrid(crid)
  }, [])
}
